// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-container[data-v-41421bb2]{white-space:nowrap;position:relative;overflow:hidden;width:100%}.scroll-container[data-v-41421bb2]  .el-scrollbar__bar{bottom:0}.scroll-container[data-v-41421bb2]  .el-scrollbar__wrap{height:49px}", ""]);
// Exports
module.exports = exports;
